import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import PlayoutDevice from './views/PlayoutDevice.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/playout-devices/:slug',
      name: 'playout-device',
      component: PlayoutDevice
    },
    {
      path: '/pools/:id/cols/:count/interval/:interval/font-size/:font_size/arrangement/:arrangement/show_images/:show_images/crop_images/:crop_images',
      name: 'preview',
      component: Home
    }
  ]
})
